import API_URLS from "../../config/BackendConfig";
import { getToken } from "../../utils/tokenUtils";
import { getRequest, postRequest } from "../../config/AxiosConfig";

const prodBaseUrl = API_URLS.PROD;
const UATBaseUrl = API_URLS.UAT;

const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer  ${token}` } : {};
};

export const AddHighMarkData = async (formData) => {
  try {
    const payload = {
      api_id: formData.api_id, // API ID
      api_key: formData.api_key, // API Key
      token_id: formData.token_id, // Token ID
      applicant_name: formData.applicant_name, // Name
      dob: formData.dob, // Date of Birth

      ids: formData.ids
        ?.filter((id) => id.type && id.value) // Only include IDs with both type and value
        .map((id) => ({
          type: id.type,
          value: id.value,
        })),

      // Phones array
      phones: formData.phones?.map((phone) => ({
        type: phone.type || "MOB",
        number: phone.number,
      })),

      // Address object
      address: {
        type: formData?.address?.type,
        address_1: formData?.address?.address_1,
        city: formData?.address?.city,
        state: formData?.address?.state,
        pin: formData?.address?.pin,
      },

      // Loan details
      loan_details: {
        inquiry_unique_ref_no: formData.loan_details.inquiry_unique_ref_no,
        cred_rpt_id: formData.loan_details.cred_rpt_id,
        cred_req_typ: formData.loan_details.cred_req_typ,
        cred_rpt_trn_id: formData.loan_details.cred_rpt_trn_id,
        cred_inq_purps_typ: formData.loan_details.cred_inq_purps_typ,
        credit_inquiry_stage: formData.loan_details.credit_inquiry_stage,
        loan_amount: formData.loan_details.loan_amount,
        mbr_id: formData.loan_details.mbr_id,
        branch_id: formData.loan_details.branch_id,
        los_app_id: formData.loan_details.los_app_id,
      },

      // Optional other details
      aadhar_no: formData.aadhar_no,
      pan_no: formData.pan_no,
      voter_id: formData.voter_id,
      ration_no: formData.ration_no,
      driving_licence: formData.driving_licence,
      passport: formData.passport,
      Gender: formData.Gender,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}crif-score/check`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error while adding HighMark data:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// export const checkTransUnionReport = async (payload) => {
//   try {
//     const response = await postRequest({
//       url: `${prodBaseUrl}credit-report/transunion`,
//       data: payload,
//       headers: getAuthHeaders(),
//     });
//     return response
//   } catch (error) {
//     return error;
//   }
// }

// Transunion Score V1
export const checkTransUnionReport = async (payload) => {
  try {
    const baseUrl = prodBaseUrl;
    const response = await postRequest({
      url: `${baseUrl}credit-report/transunion`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

// Transunion Score V2
export const checkTransUnionReport2 = async (payload) => {
  try {
    const baseUrl = prodBaseUrl;
    const response = await postRequest({
      url: `${baseUrl}srv2/credit-report/cibil`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

// Transunion Score V3
export const checkTransUnionReport3 = async (payload) => {
  try {
    const baseUrl = prodBaseUrl;
    const response = await postRequest({
      url: `${baseUrl}srv3/credit-report/transunion`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const checkExperianCreditReport = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}credit-report/experian`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const checkEquifaxV2CreditScore = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}credit-report/equifax`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

// Consumer Detials with Mobile
export const V2VerifyMobile = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/credit-report/consumer-details`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

// Mobile Check Score
export const checkScoreService = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/credit-report/check-score`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

// Score Prefill
export const checkScorePrefillService = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/credit-report/prefill`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

// Experian V2
export const checkExperianCreditReport2 = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/credit-report/experian`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

// Experian V3
export const checkExperianCreditReport3 = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv3/credit-report/experian`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

// Crif Score
export const checkCrifCreditScore = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv3/credit-report/crif`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

// Crif Score V2
export const checkCrifCreditScore2 = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/credit-report/crif`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

// Crif Score V3


export const checkCrifCreditScore4 = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}crif/Credit-ScoreV4`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const checkCrifCreditScore3 = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}crif/Credit-ScoreV3`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};



export const crifScoreCheck = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}crif/Crif-Score`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};



export const checkTransUnionReportHybrid = async (payload) => {
  try {
    const baseUrl = prodBaseUrl;
    const response = await postRequest({
      url: `${baseUrl}srv5/transunion-Score-Hybrid`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return error;
  }
};